export default __webpack_public_path__ + "static/media/videoNew.5e99e701.mp4";